import { HSConfiguration } from './hs-configuration';

export class SlidingDoorConfiguration extends HSConfiguration {
    type: 'sliding_door' = 'sliding_door';
}
